import { ConsoleLogger, LogLevel } from "@fds/wm-typescript-mdg2-client";

const logger = new ConsoleLogger();
logger.setLevel(LogLevel.DEBUG);

export { logger };
